import {
  RESET_MAYA_STATE,
  IS_PLAN_REQUESTED,
  IS_CHAT_READY,
  ANIMATE_DEFAULT_MESSAGES,
  FETCH_ORGANIZATION_DETAILS_FULFILLED,
  ADD_NEW_MESSAGE,
  REMOVE_EXISTING_MESSAGE,
  SET_REGENERATE_RESPONSE,
  FETCH_CHAT_FULFILLED,
  SET_FETCH_INTENT_STATE,
  SET_INTENT_GRID,
  REQUEST_PLAN_FULFILLED,
  SET_IS_GRID_MODE,
  ADD_MAYA_RESPONSE,
  SET_MAYA_CHAT_RESPONSE,
  IS_MAYA_RESPONDING,
  SET_SOCKET_CONNECTION_ESTABLISHED,
  FETCH_DEFAULT_CHAT_FULFILLED,
  GET_DEFAULT_TRIPS_FULFILLED,
  IS_EXPECTING_ASSISTANT_RESPONSE,
  SET_IS_TEST_CASE,
  FETCH_SEARCH_RESULTS_FULFILLED,
  DEFAULT_SEARCH_RESULTS,
  SET_SEARCH_QUERY,
  SET_IS_FETCHING_SEARCH_RESULTS,
  SET_MAYA_AI_QUERY_RESPONSE,
  SET_IS_FETCHING_AI_QUERY_RESPONSE,
  SET_MAYA_AI_QUERY_TOKEN,
  SET_IS_INTERNAL_CASE,
  SET_GENERATE_AI_QUERY_RESPONSE,
  FETCH_SEARCH_RESULTS_REJECTED,
  SET_IS_INTERNAL_CASE_IN_QUERY_OR_OPTIONS,
  SET_ORGANIZATION_DETAILS_ERROR,
  SET_SHOW_FEEDBACK_MODAL,
  SET_USER_HAS_SENT_MESSAGE,
  SET_LAST_ACTIVE_TIME,
  UPDATE_EXISTING_MESSAGE,
  SET_BRAND,
  UPDATE_ASSISTANT_RESPONSE_ID,
  ADD_POPOVER_NOTIFICATION_MESSAGE,
} from './constants'
import initialState from './state'
import {
  getMayaCookieNameChatSlug,
  getMayaCookieNameChatToken,
  saveChatTokenAndSlugToCookie,
} from '../../utils/helpers'
import cloneDeep from 'lodash.clonedeep'
import cookie from 'react-cookies'

const setOrganizationDetails = (state, action) => {
  const newState = cloneDeep(state)

  if (action.payload?.defaultMessages?.length) {
    const rows = cloneDeep(action.payload.defaultMessages)

    let defaultMessages = []
    let quickReplies = []
    let popoverNotificationMessage = ''
    for (let row of rows) {
      if (row?.messageType === 'conversation_log') {
        defaultMessages.push(row)
      } else if (row?.messageType === 'quick_replies') {
        quickReplies.push(row)
      } else if (row?.messageType === 'popover_notification_message') {
        popoverNotificationMessage = row.content
      }
    }

    newState.defaultMessages = defaultMessages
    newState.quickReplies = quickReplies
    newState.popoverNotificationMessage = popoverNotificationMessage
  }

  if (
    action.payload?.defaultSearches?.length &&
    action.payload?.defaultSearches[0].log?.quickSearches
  ) {
    newState.quickSearches = action.payload.defaultSearches[0].log.quickSearches
  }

  // Get notification message delay and once per session from configs
  if (action.payload?.configs?.length) {
    const config = action.payload.configs[0]
    if (config.popoverNotificationMessageDelay !== undefined) {
      newState.popoverNotificationMessageDelay =
        config.popoverNotificationMessageDelay
    }
    if (config.popoverNotificationOncePerSession !== undefined) {
      newState.popoverNotificationOncePerSession =
        config.popoverNotificationOncePerSession
    }
    if (config.popoverNotificationDuration !== undefined) {
      newState.popoverNotificationDuration = config.popoverNotificationDuration
    }
  }

  newState.organizationDetails = action.payload

  return newState
}

const addPopoverNotificationMessage = (state, action) => {
  const newState = cloneDeep(state)

  newState.customPopoverNotificationMessage = action.payload

  return newState
}

const animateDefaultMessages = (state, action) => {
  const newState = cloneDeep(state)

  if (action.payload.isNewMessage) {
    newState.messages.push(action.payload.message)
  } else {
    newState.messages[newState.messages.length - 1] = action.payload.message
  }

  return newState
}

const setDefaultChatFromServer = (state, action) => {
  const newState = cloneDeep(state)

  newState.slug = action.payload.slug
  newState.token = action.payload.token
  newState.readOnlyMode = false

  let cookieNameChatSlug = getMayaCookieNameChatSlug({
    language: action.payload.language,
    organizationSlug: action.payload.organization.slug,
    chatMode: action?.payload?.organization?.clients?.length ? 'b2b' : 'b2c',
  })

  let cookieNameChatToken = getMayaCookieNameChatToken({
    language: action.payload.language,
    organizationSlug: action.payload.organization.slug,
    chatMode: action?.payload?.organization?.clients?.length ? 'b2b' : 'b2c',
  })

  // SET SLUG AND TOKEN IN COOKIES
  // COOKIE LIFE IS 24HRS
  cookie.save(cookieNameChatSlug, newState.slug, {
    path: '/',
    maxAge: 86400,
    domain: window.location.hostname,
  })
  cookie.save(cookieNameChatToken, newState.token, {
    path: '/',
    maxAge: 86400,
    domain: window.location.hostname,
  })

  return newState
}

const pushNewMessage = (state, action) => {
  const newState = cloneDeep(state)

  newState.messages.push(action.payload)
  return newState
}

const setIntentResponse = (state, action) => {
  const newState = cloneDeep(state)

  newState.intent = action.payload
  return newState
}

const setDefaultTrips = (state, action) => {
  const newState = cloneDeep(state)

  newState.intent = action.payload

  return newState
}

const setSearchResults = (state, action) => {
  const newState = cloneDeep(state)

  newState.searchResults = action.payload.data
  newState.searchSlug = action.payload.slug

  return newState
}

const resetSearchResults = (state, action) => {
  const newState = cloneDeep(state)

  newState.searchResults = null
  newState.searchSlug = null

  return newState
}

const setChatResponse = (state, action) => {
  const newState = cloneDeep(state)

  newState.intent = action.payload.intent
  newState.slug = action.payload.slug
  newState.token = action.payload.token

  // CASE WHEN MESSAGES ARE NOT TO BE ANIMATED
  if (action.payload.chatMessages) {
    newState.messages = action.payload.chatMessages
  }

  newState.readOnlyMode = action.payload.readOnly || false

  if (action.payload?.defaultMessages?.length) {
    const rows = cloneDeep(action.payload.defaultMessages)

    let defaultMessages = []
    let quickReplies = []
    let popoverNotificationMessage = ''
    for (let row of rows) {
      if (row?.messageType === 'conversation_log') {
        defaultMessages.push(row)
      } else if (row?.messageType === 'quick_replies') {
        quickReplies.push(row)
      } else if (row?.messageType === 'popover_notification_message') {
        popoverNotificationMessage = row.content
      }
    }

    newState.defaultMessages = defaultMessages
    newState.quickReplies = quickReplies
    newState.popoverNotificationMessage = popoverNotificationMessage
  }

  return newState
}

const addMayaResponse = (state, action) => {
  const newState = cloneDeep(state)

  newState.messages.push({
    role: 'assistant',
    content: '',
    id: action.payload.id,
  })

  return newState
}

const removeExistingMessage = (state, action) => {
  const newState = cloneDeep(state)

  // GET ALL MESSAGES NOT MATCHING THE RECIEVED ID
  newState.messages = newState.messages.filter(
    message => message.id !== action.payload.id
  )

  return newState
}

const setMayaChatResponse = (state, action) => {
  const newState = cloneDeep(state)

  if (!action?.payload?.chunk) return newState

  const chunk = action.payload.chunk

  let mayaResponse = cloneDeep(newState.messages[newState.messages.length - 1])

  // ITERATE THROUGH ALL CHUNKS AND ADJUST IN MESSAGE
  if (chunk?.intent) {
    mayaResponse['intent'] = chunk.intent
  }
  if (chunk?.content) {
    mayaResponse['content'] = mayaResponse['content'] + chunk.content
  }
  if (chunk?.id) {
    mayaResponse['id'] = chunk.id
  }
  if (chunk?.showFeedbackCTA) {
    mayaResponse['showFeedbackCTA'] = chunk.showFeedbackCTA
  }

  if (chunk?.slug) {
    newState.slug = chunk.slug
  }
  if (chunk?.token) {
    newState.token = chunk.token
  }

  newState.messages[newState.messages.length - 1] = mayaResponse

  return newState
}

const setRequestPlanResponse = (state, action) => {
  const newState = cloneDeep(state)

  if (action.payload?.messages?.length) {
    newState.messages.push(...action.payload.messages)
    newState.planRequested = true
  }

  return newState
}

const setIsGridMode = (state, action) => {
  const newState = cloneDeep(state)

  newState.isGridMode = action.payload

  if (action.payload) {
    // SET IN COOKIE THAT GRID MODE IS CURRENTLY OPEN
    cookie.save(`maya_is_grid_mode_${process.env.REACT_APP_API_ENV}`, 'true', {
      path: '/',
      maxAge: 86400,
      domain: window.location.hostname,
    })
  } else {
    // REMOVE GRID MODE OPEN CASE FROM COOKIE
    cookie.remove(`maya_is_grid_mode_${process.env.REACT_APP_API_ENV}`, {
      path: '/',
      domain: window.location.hostname,
    })
  }

  return newState
}

const updateExistingMessage = (state, action) => {
  const newState = cloneDeep(state)
  let messages = cloneDeep(newState.messages)

  // Use a loop with an index to update the array correctly
  for (let i = 0; i < messages.length; i++) {
    if (messages[i].id === action.payload.id) {
      messages[i] = action.payload // Update the message in the array
      break // Exit the loop after finding the match
    }
  }

  newState.messages = messages
  return newState // Make sure to return the new state
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_MAYA_STATE:
      return { ...initialState }
    case SET_ORGANIZATION_DETAILS_ERROR:
      return { ...state, organizationDetailsError: action.payload }
    case IS_PLAN_REQUESTED:
      return { ...state, isPlanRequested: action.payload }
    case IS_CHAT_READY:
      return { ...state, isChatReady: action.payload }
    case ANIMATE_DEFAULT_MESSAGES:
      return animateDefaultMessages(state, action)
    case FETCH_ORGANIZATION_DETAILS_FULFILLED:
      return setOrganizationDetails(state, action)
    case FETCH_DEFAULT_CHAT_FULFILLED:
      return setDefaultChatFromServer(state, action)
    case ADD_NEW_MESSAGE:
      return pushNewMessage(state, action)
    case SET_INTENT_GRID:
      return setIntentResponse(state, action)
    case FETCH_CHAT_FULFILLED:
      return setChatResponse(state, action)
    case SET_REGENERATE_RESPONSE:
      return { ...state, regenerateResponse: action.payload }
    case SET_FETCH_INTENT_STATE:
      return { ...state, isFetchingIntent: action.payload }
    case REQUEST_PLAN_FULFILLED:
      return setRequestPlanResponse(state, action)
    case SET_IS_GRID_MODE:
      return setIsGridMode(state, action)
    case ADD_MAYA_RESPONSE:
      return addMayaResponse(state, action)
    case REMOVE_EXISTING_MESSAGE:
      return removeExistingMessage(state, action)
    case SET_MAYA_CHAT_RESPONSE:
      return setMayaChatResponse(state, action)
    case IS_MAYA_RESPONDING:
      return { ...state, isMayaResponding: action.payload }
    case SET_SOCKET_CONNECTION_ESTABLISHED:
      return { ...state, isSocketConnectionEstablished: action.payload }
    case GET_DEFAULT_TRIPS_FULFILLED:
      return setDefaultTrips(state, action)
    case IS_EXPECTING_ASSISTANT_RESPONSE:
      return { ...state, isExpectingAssistantResponse: action.payload }
    case SET_IS_TEST_CASE:
      return { ...state, isTestCase: action.payload }
    case SET_IS_INTERNAL_CASE:
      return { ...state, isInternalCase: action.payload }
    case SET_IS_INTERNAL_CASE_IN_QUERY_OR_OPTIONS:
      return { ...state, isInternalCaseInQueryOrOptions: action.payload }
    case SET_GENERATE_AI_QUERY_RESPONSE:
      return { ...state, generateAiQueryResponse: action.payload }
    case FETCH_SEARCH_RESULTS_FULFILLED:
      return setSearchResults(state, action)
    case FETCH_SEARCH_RESULTS_REJECTED:
      return resetSearchResults(state, action)
    case DEFAULT_SEARCH_RESULTS:
      return { ...state, defaultSearchResults: action.payload }
    case SET_SEARCH_QUERY:
      return { ...state, searchQuery: action.payload }
    case SET_IS_FETCHING_SEARCH_RESULTS:
      return { ...state, isFetchingSearchResults: action.payload }
    case SET_MAYA_AI_QUERY_RESPONSE:
      return { ...state, searchAiTextResponse: action.payload }
    case SET_IS_FETCHING_AI_QUERY_RESPONSE:
      return { ...state, isFetchingAiQueryResponse: action.payload }
    case SET_MAYA_AI_QUERY_TOKEN:
      return { ...state, aiSearchQueryToken: action.payload }
    case SET_SHOW_FEEDBACK_MODAL:
      return { ...state, showFeedbackModal: action.payload }
    case SET_USER_HAS_SENT_MESSAGE:
      return { ...state, userHasSentMessage: action.payload }
    case SET_LAST_ACTIVE_TIME:
      return { ...state, lastActiveTime: action.payload }
    case UPDATE_EXISTING_MESSAGE:
      return updateExistingMessage(state, action)
    case SET_BRAND:
      return { ...state, brand: action.payload }
    case ADD_POPOVER_NOTIFICATION_MESSAGE:
      return addPopoverNotificationMessage(state, action)
    case UPDATE_ASSISTANT_RESPONSE_ID:
      return {
        ...state,
        messages: state.messages.map(message =>
          message.id === action.payload.tempId
            ? { ...message, id: action.payload.id }
            : message
        ),
      }
    default:
      return state
  }
}

export default reducer
